import React from 'react';
import { StandardProps } from '@/newcar/ui/contract';
import * as scss from './index.module.styl';

interface BaseSectionFieldProps
  extends StandardProps {
  id: string;
  children: React.ReactNode;
  borderHidden?: boolean;
}
// #endregion

declare type SectionProps = BaseSectionFieldProps;

/**
 * Section
 *
 * @export
 * @param {SectionProps} props
 * @return {*}  {JSX.Element}
 */
export default function Section(props: SectionProps): JSX.Element {
  const {
    id,
    borderHidden = false,
    className = '',
    children,
    style,
  } = props;

  return (
    <section
      id={id}
      className={`${scss.section} ${!borderHidden ? scss.border : ''} ${className}`}
      style={style}
    >
      {children}
    </section>
  );
}
